import { lazy } from 'react';

/** Lazy-load a module and expose a named (or default) export as the default. */
export function lazyNamed(importer, exportName) {
  return lazy(() =>
    importer().then((mod) => ({
      default: exportName ? (mod[exportName] || mod.default) : mod.default,
    })),
  );
}
